import React, { StrictMode , Component} from "react";
import ReactDOM,{ createRoot } from "react-dom/client";
//import bootstrap from 'bootstrap' ;
// Bootstrap CSS
//import "bootstrap/dist/css/bootstrap.min.css";
//import "@popperjs/core/dist/umd/popper.min.js";
// Bootstrap Bundle JS
//import "bootstrap/dist/js/bootstrap.bundle.min.js";


import { BrowserRouter, Routes, Route , Router } from "react-router-dom";

 import Layout from "./Layout/Layout";
 import Home from "./Pages/Home";
  import AboutUs from "./Pages/AboutUs";
   import ContactUs from "./Pages/ContactUs";
    import ChangePassword from "./Pages/ChangePassword";
	  import Logout from "./Pages/Logout";
	 import CifclTa from "./Pages/CholaTARequest";
	 import PageNotFound from "./Pages/PageNotFound";


const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
  <BrowserRouter>

         <Routes> 
		     <Route   path="/" element={<Layout/>}>
			
		        <Route index element={<Home />}></Route>
				<Route  path="about" element={<AboutUs/>}></Route>
				<Route  path="ContactUs" element={<ContactUs/>}></Route>
				<Route  path="changePassword" element={<ChangePassword/>}></Route>
				<Route  path="logout" element={<Logout/>}></Route>
				<Route  path="cifcl_ta_letter" element={<CifclTa/>}></Route>
				<Route  path="*" element={<PageNotFound />}></Route>
			</Route>
        </Routes>
		
     </BrowserRouter> 
     

  
  	
  
  </StrictMode>
);